import { useQuery } from "@tanstack/react-query";
import { getScores, getMeta } from "../lib/api";
import { GameCard } from "../components/GameCard";

export default function Scores() {
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: getMeta });
  const { data: games = [], isLoading } = useQuery({ queryKey: ["scores"], queryFn: getScores, refetchInterval: 60_000 });

  const live = games.filter((g) => g.status === "live");
  const final = games.filter((g) => g.status === "final");
  const upcoming = games.filter((g) => g.status === "scheduled");

  return (
    <div data-testid="scores-page" className="space-y-8">
      <div className="flex items-end justify-between border-b-2 border-border pb-2">
        <h1 className="font-display text-5xl">SCORES</h1>
        <span data-testid="scores-season-label" className="label-caps">{meta?.gamesSeason} · Week {meta?.currentWeek}</span>
      </div>

      {isLoading && <p className="text-muted-foreground">Loading scores…</p>}

      {live.length > 0 && (
        <section>
          <h2 className="flex items-center gap-2 font-display text-3xl text-accent mb-4">
            <span className="w-3 h-3 rounded-full bg-accent live-dot" /> LIVE NOW
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {live.map((g) => (
              <GameCard key={g.id} game={g} />
            ))}
          </div>
        </section>
      )}

      {final.length > 0 && (
        <section>
          <h2 className="font-display text-3xl mb-4">FINAL</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {final.map((g) => (
              <GameCard key={g.id} game={g} />
            ))}
          </div>
        </section>
      )}

      {upcoming.length > 0 && (
        <section data-testid="scores-upcoming">
          <h2 className="font-display text-3xl mb-1">UP NEXT</h2>
          <p className="text-sm text-muted-foreground mb-4">
            No games played yet this week. Scores go live here at kickoff.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {upcoming.map((g) => (
              <GameCard key={g.id} game={g} />
            ))}
          </div>
        </section>
      )}

      {!isLoading && games.length === 0 && (
        <p className="text-muted-foreground">No games in progress right now.</p>
      )}
    </div>
  );
}
